import { JsonEditor, githubDarkTheme } from 'json-edit-react';
import React, { memo, useCallback } from 'react';

interface JsonViewerProps {
	data: any;
	setTemplateJSON: (data: any) => void;
	store?: any;
}

const JsonViewer: React.FC<JsonViewerProps> = memo((props) => {
	const { data, setTemplateJSON, store } = props;

	// Handle JSON changes and update the polotno store
	//TODO: handle this and save it to the template json
	const handleJSONChange = useCallback(
		(updatedData: any) => {
			try {
				// Update the template JSON state
				setTemplateJSON(updatedData);

				// If store is provided, update the polotno store as well
				if (store && updatedData.json) {
					store.loadJSON(updatedData.json);
				}
			} catch (error) {
				console.error('Error updating JSON:', error);
			}
		},
		[setTemplateJSON, store],
	);

	return (
		<div className="json-viewer">
			<JsonEditor
				collapse={2}
				data={data}
				enableClipboard={true}
				restrictAdd={true}
				restrictDelete={true}
				restrictEdit={true}
				rootFontSize={12}
				rootName="template"
				setData={handleJSONChange}
				theme={githubDarkTheme}
			/>
		</div>
	);
});

export default JsonViewer;
